import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IIndustry {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  agricultureForestryFishing?: number | null;
  miningQuarrying?: number | null;
  manufacturing?: number | null;
  electricityGasWater?: number | null;
  construction?: number | null;
  wholesaleRetailTrade?: number | null;
  transportationStorage?: number | null;
  accommodationFoodService?: number | null;
  informationCommunication?: number | null;
  financialInsurance?: number | null;
  realEstate?: number | null;
  professionalScientific?: number | null;
  administrativeSupport?: number | null;
  publicAdministration?: number | null;
  education?: number | null;
  humanHealthSocialWork?: number | null;
  artsEntertainment?: number | null;
  otherServiceActivities?: number | null;
  householdEmployers?: number | null;
}

export const defaultValue: Readonly<IIndustry> = {};
